import React, { Component } from 'react';

class WhatWeBelieve extends Component {

  render() {
    return (
      <section>
        <div id="top-content-region" className="top-content padding-top-15 padding-bottom-15 block-15 bg-color-grayLight1">
          <div className="container">
            <div className="row">
              <div id="top-content-left-region" className="top-content-left col-xs-12 col-md-6 text-center-sm">
                <div id="page-title-block" className="page-title block">
                  <h1>What We Believe</h1>
                </div>
              </div>

              <div id="top-content-right-region" className="top-content-right col-xs-12 col-md-6 text-right text-center-sm">
                <div id="page-breadcrumbs-block" className="page-breadcrumbs block">
                  <div className="breadcrumbs">
                    <a href="/">Home</a>
                    <span className="delimiter">›</span>
                    <span title="" className="nolink">Visit Us</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="content-region">
          <div className="container">
            <div className="row">
              <div id="main-content-region" className="main-content col-xs-12">
                <div className="region region-content">
                  <div id="block-system-main" className="block block-system">
                    <div className="content">
                      <div className="node node-page clearfix">
                        <div className="content">
                          <h2 className="header-lightBlue">Doctrine</h2>
                          <p className="ministry-text">The supreme standard by which our Church&apos;s belief and practice is  measured is the Word of God: the sixty-six books of the Old and New Testaments of the Bible.
                          <br /><br />
                          So that others can clearly understand what the Presbyterian Church of Australia believes is taught in the Bible, the PCA has adopted the <a href="/WestminsterConfession">The Westminster Confession of Faith</a> as a statement of its key doctrines. While the Church believes the Confession sets forth Biblical doctrines accurately and reliably, the Confession is always referred to as the subordinate standard, and the Bible as the only supreme standard.</p>
                          <h2 className="header-lightBlue">Worship</h2>
                          <p>We seek to worship God in every part of life: hour to hour, day to day, and year after year. "So whether you eat or drink or whatever you do, do it all for the glory of God!" (1 Corinthians 10:31).
                        <br/><br/> Our Sunday service is a special time of corporate worship.  We praise Jesus by singing, praying, reading and preaching His Word, and celebrating the sacraments of baptism and the Lord&apos;s Supper.</p>

                        </div>



                </div>
                  </div>
                </div>  </div>



                        </div>




                      </div>
                    </div>
                  </div>
      </section>
    );
  }
}

export default WhatWeBelieve;
